import React from "react";
import { useParams, Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import ScrollToTopButton from "./ScrollToTopButton";


const EyeServices = () => {
  const { id } = useParams();
  const serviceId = parseInt(id || 1);

  const eyeServices = [
    {
      id: 1,
      title: " Phacoemulsification (Phaco Surgery)",
      description: "Phacoemulsification, commonly known as Phaco Surgery, is a modern cataract removal technique. It is a painless, stitchless, and highly advanced procedure that uses topical anesthesia—meaning no injection is required. The surgery does not require an eye patch and allows for a quicker recovery. A foldable intraocular lens (IOL) is implanted through a small incision, enabling faster healing and better visual outcomes. It is considered one of the safest and most effective methods for treating cataracts today.",
      image: "/eye/eye15.webp",
    },
    {
      id: 2,
      title: "Cataract",
      description: "A cataract is an eye condition characterized by the clouding of the natural lens in the eye, leading to vision loss. Naturally, the eye's lens is clear and allows light to pass through, focusing on the retina at the back of the eye. but when a cataract develops, the lens becomes cloudy and interferes with the normal passage of light.",
      image: "/eye/eye1.png",
    },
    {
      id: 3,
      title: "Diabetic Retinopathy",
      description: "Diabetic retinopathy is an eye condition, it is caused by diabetes that occurs due to damage to the blood vessels in the retina, the light-sensitive tissue at the back of the eye. When diabetes is not well managed, it can lead to high levels of blood sugar, which in turn can cause damage to blood vessels throughout the body including those in the retina.",
      image: "/eye/eye2.png",
    },
    {
      id: 4,
      title: "Cornea and Associated Diseases",
      description: "The cornea is the transparent front part of the eye that covers the iris, pupil, and anterior parts of an eye. The cornea is composed of specialized cells and proteins and lacks blood vessels to maintain transparency. The conditions that affect the cornea are called corneal diseases.",
      image: "/eye/eye3.png",
    },
    {
      id: 5,
      title: "Glaucoma Treatment",
      description: "Glaucoma is an eye condition that directly damages the optic nerve (the bundle of nerve fibers that carries information from the eye to the brain). This damage is often caused by an increased pressure in the eye, known as intraocular pressure (IOP). The optic nerve is crucial for vision, and if it becomes damaged, it can lead to vision loss and blindness.",
      image: "/eye/eye4.png",
    },
    {
      id: 6,
      title: "Neuro-Ophthalmology",
      description: "Neuro ophthalmology is a combination of super specialty of both neurology and ophthalmology. This field deals with the complicated conditions or diseases between the brain and eyes that affect eye movement, vision, alignment, and pupillary reflexes.",
      image: "/eye/eye5.webp",
    },
    {
      id: 7,
      title: "Oculoplasty",
      description: "Oculoplasty, also known as oculoplastic surgery is a specialized branch of ophthalmology that focuses on the disease diagnosis, affecting the structures around the eyes, including the eyelids, tear ducts, orbit (eye socket), and the surrounding facial tissues. The term oculoplasty is derived from the combination of oculo (related to the eye) and plasty (surgery or reconstruction).",
      image: "/eye/eye6.png",
    },
    {
      id: 8,
      title: "Pediatric Ophthalmology",
      description: "Pediatric ophthalmology is a subspecialty of ophthalmology, that focuses on children's eye health. It involves diagnosing and treating eye problems in infants, children, and adolescents.",
      image: "/eye/eye7.png",
    },
    {
      id: 9,
      title: "Refractive Surgeries",
      description: "Refractive surgeries are a group of surgical procedures designed to improve or correct vision by reshaping the cornea or, in some cases, by using an intraocular lens. These surgeries are typically performed to address common vision problems such as near-sightedness (myopia), farsightedness (hyperopia), and astigmatism.",
      image: "/eye/eye8.png",
    },
    {
      id: 10,
      title: "Retina and Associated Diseases",
      description: "The retina is a thin layer of tissue at the back of the eye that plays a crucial role in vision. It contains cells,  sensitive to light and is responsible for converting light signals into electrical impulses and sent to the brain through the optic nerve. Various disorders can affect the retina, leading to vision problems.",
      image: "/eye/eye9.png",
    },
    
    {
      id: 11,
      title: " LASIK Surgery",
      description: "LASIK (Laser-Assisted In Situ Keratomileusis) or laser eye treatment is a popular laser eye surgery technique that is used to correct conditions related to vision such as myopia (nearsightedness), hyperopia (farsightedness), and astigmatism. Lasik laser eye surgery aims to clear the front part of the eye, reshape the cornea, and improve how the eye focuses light onto the retina.",
      image: "/eye/eye10.png",
    },
    {
      id: 12,
      title: "ICL Eye Surgery",
      description: "ICL or Implantable Collamer Lens surgery is a type of refractive surgery, in which an artificial lens is implanted in the eyes permanently. ICL is required to treat moderate to severe Nearsightedness (Myopia), Farsightedness (Hyperopia), and Astigmatism. This surgery may be possible for people who don’t meet the criteria for LASIK surgery.",
      image: "/eye/eye12.png",
    },
    {
      id: 13,
      title: "Photorefractive Keratectomy",
      description: "Photorefractive keratectomy is a type of laser eye surgery, that is used to treat refractive errors, Nearsightedness (myopia), Farsightedness (hyperopia), and Astigmatism) with an excimer laser (A computer-generated, cold laser beam), used to remove and sculpt corneal tissue at the microscopic level. This treatment aims to reduce an individual's dependency on glasses and contact lenses.",
      image: "/eye/eye13.png",
    },
    {
      id: 14,
      title: "Squint Eye",
      description: "Squint eye or strabismus is one of the neurological visual disorders whereby the normal neurologic balance between the muscles controlling eye movement is disrupted, leading to misaligned eyes that cannot point at a common point simultaneously. One eye may look directly ahead as the other eye turns inward, outward, upward, or even downward. This misalignment could occur all the time or only some of the time.",
      image: "/eye/eye14.jpg",
    },
  ];

  const service = eyeServices.find((s) => s.id === serviceId) || eyeServices[0];

  return (
    <div className="min-h-screen bg-white mt-[120px]">
      {/* Main Content Area */}
      <div className="bg-blue-600 py-16">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="md:w-1/2 mb-6 md:mb-0">
              <h1 className="text-4xl font-bold text-white mb-4">
                What Do You Understand by {service.title}?
              </h1>
              <p className="text-white text-lg">
                {service.description}
              </p>
              <div className="mt-6 flex flex-col sm:flex-row gap-4">
              <Link
  to="/specialities"
  className="inline-flex items-center text-white text-lg hover:underline"
>
  <FiArrowLeft className="mr-2 text-white text-2xl" />
  Back 
</Link>

<a href="tel:8788061100">
  <button className="bg-white text-blue-600 px-6 py-3 rounded-md hover:bg-gray-100 transition-colors font-medium">
    Call Now
  </button>
</a>

              </div>
            </div>
            <div className="md:w-2/5">
              <div className="bg-white rounded-full p-4">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-auto rounded-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ScrollToTopButton />
    </div>
  );
};

export default EyeServices;
